import InputBase from "@mui/material/InputBase";
import TableCell from "@mui/material/TableCell";
import { makeStyles, withStyles } from "@mui/styles";

const { innerHeight: height } = window;

export const containerMaxHeight = height * 0.72;

export const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: height * 0.72,
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  table: {
    minWidth: 650,
  },
  paper: {
    width: "100%",
    marginBottom: 16,
  },
  rootPaginator: {
    flexShrink: 0,
    marginLeft: 20,
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    padding: 16, // theme.spacing(2)
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    outline: "none",
  },
  cuponModal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    padding: "16px 32px 24px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    outline: "none",
  },
  mapModal: {
    position: "absolute",
    width: "60%",
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    padding: "16px 32px 24px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    outline: "none",
  },
  colorModal: {
    position: "absolute",
    width: 600,
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    padding: "16px 32px 24px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    outline: "none",
  },
  rentalModal: {
    position: "absolute",
    width: 1200,
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    padding: "16px 32px 24px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    outline: "none",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: 8,
    position: "relative",
    width: "100%",
  },
  buttonStyle: {
    fontSize: "0.77rem",
    fontWeight: "bold",
  },
  pagination: {
    "& .MuiToolbar-root": {
      justifyContent: "center",
    },
    "& .MuiTablePagination-spacer": {
      display: "none",
    },
  },
}));

export const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#f9f9f9",
  },
}))(TableCell);

export const SelectorInput = withStyles(() => ({
  input: {
    borderRadius: 4,
    borderColor: "#80bdff",
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    position: "relative",
    backgroundColor: "#fff",
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: "border-color 300ms, box-shadow 300ms",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

export const style = {
  modalText: {
    width: "100%",
    marginBottom: 10,
  },
  searchText: {
    marginBottom: 10,
  },
};

export const classNames = {
  root: "w-full",
  container: "",
  input: "ml-2 flex-1",
  iconButton: "p-2.5",
  table: "min-w-[650px]",
  paper: "w-full mb-4",
  rootPaginator: "flex-shrink-0 ml-5",
  buttonProgress: "absolute top-1/2 left-1/2 -mt-3 -ml-3",
  wrapper: "m-2 relative w-full",
  buttonStyle: "text-xs font-bold",
  pagination: "flex justify-center",
};

export const styledTableCellClass = "bg-gray-50";
